import { useMutation, useQuery } from '@tanstack/react-query';

import type { ExportTypeDto } from '@adflow/frontend/ui-common';
import { apiRequest } from '@adflow/frontend/util-query';
import type { ListFacebookPagesQuery } from '@adflow/shared/data-facebook-ads';
import {
	CreateFacebookPagesExport,
	ListFacebookPages,
} from '@adflow/shared/data-facebook-ads';

const facebookPageKeys = {
	all: ['facebook', 'page'] as const,
	allList: () => [...facebookPageKeys.all, 'list'] as const,
	list: (query: ListFacebookPagesQuery) =>
		[...facebookPageKeys.allList(), query] as const,
};

export function useListFacebookPagesQuery(
	query: ListFacebookPagesQuery,
	enabled = true
) {
	return useQuery({
		queryKey: facebookPageKeys.list(query),
		queryFn: ({ signal }) =>
			apiRequest(ListFacebookPages, { query }, { signal }),
		enabled,
	});
}

export function useExportFacebookPagesMutation(
	filter: ListFacebookPagesQuery,
	columns: string[]
) {
	return useMutation({
		mutationFn: (type: ExportTypeDto) =>
			apiRequest(CreateFacebookPagesExport, {
				body: {
					filter,
					columns,
					type,
				},
			}),
	});
}
